import { ListItem, ListProps } from "baseui/list";

interface SelectableListItemProps extends ListProps {
    item: any,
    isSelected?: boolean
    onSelect?: (item: any) => void,
}
const SelectableListItem = (props: SelectableListItemProps) => {

    const handelClick = () => { if (props.onSelect) props.onSelect(props.item); };

    return (
        <ListItem
            {...props}
            onClick={handelClick}
            overrides={props.isSelected ? {
                Root: {
                    style: ({ $theme }) => ({
                        backgroundColor: $theme.colors.accent100,
                        borderRadius: '5px',
                        ":hover": {
                            backgroundColor: $theme.colors.accent50,
                            borderRadius: $theme.sizing.scale100,
                        },
                    })
                }
            } : {
                Root: {
                    style: ({ $theme }) => ({
                        ":hover": {
                            backgroundColor: $theme.colors.backgroundSecondary,
                            borderRadius: $theme.sizing.scale100,
                        },
                    })
                }
            }}
        >
            {props.children}
        </ListItem>
    )
}

export default SelectableListItem;

